var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqGravelGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_355",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86667 28C5.44444 27.9111 5.05 27.6833 4.68333 27.3167C4.31667 26.95 4.08889 26.5556 4 26.1333L26.1333 4C26.6 4.11111 27 4.33889 27.3333 4.68333C27.6667 5.02778 27.9 5.42222 28.0333 5.86667L5.86667 28ZM4 19.6V15.8667L15.8667 4H19.6L4 19.6ZM4 9.33333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H9.33333L4 9.33333ZM22.6667 28L28 22.6667V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H22.6667ZM12.4 28L28 12.4V16.1333L16.1333 28H12.4Z",
    fill: "#ADAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqGravelGrey);
export default __webpack_public_path__ + "static/media/req_gravel_grey.978fb6914a5c2dd6cb495a004431ef35.svg";
export { ForwardRef as ReactComponent };